/** LinkedIn company activity strings (extracted from en.ts to keep it under the size ratchet). */
export const enLiCompanyActivity = {
	title: "LinkedIn Company Activity",
	search: "Search for Company Activity",
	name: "Name",
	subtitle: "Your LinkedIn Company Activity",
	url: "Linkedin Company Page URL",
	urlTitle: "URLs",
	status: "Status",
	type: "Type",
	titlePerson: "Title",
	headline: "Headline",
	linkedinUrl: "LinkedIn URL",
	content: "Content",
	contentResponse: "Content Response",
	country: "Personal Country",
	city: "Personal City",
	companyName: "Company Name",
	companyLinkedinUrl: "Company LinkedIn URL",
	companyCountry: "Company Country",
	companyCity: "Company City",
	create: {
		button: "Create new Company Activity Scraper",
		title: "Create new Company Activity Scraper",
	},
	update: {
		title: "Update Company Activity Scraper",
	},
	tabs: {
		results: "Results",
		costs: "Costs",
	},
	scrapeFollowers: "Scrape Followers",
	scrapeFollowersWarning: "Attention: You need admin rights on the LinkedIn page for this",
	timeframe: "How long back should engagement be tracked?",
	timeframePlaceholder: "30",
	namePlaceholder: "Signalist",
	urlPlaceholder: "https://www.linkedin.com/company/103955748/",
	amount: "Maximum amount of followers",
	amountPlaceholder: "1000",
	NOW: "Now",
	THIS_MONTH: "This month",
	LAST_MONTH: "Last month",
	LAST_3_MONTHS: "Last 3 months",
	LAST_6_MONTHS: "Last 6 months",
	LAST_YEAR: "Last 12 months",
	delete: {
		title: "Delete company activity source",
	},
};
